import { useMemo } from 'react';
import { useTownsContext } from '../components/TownsContextProvider';
import { userIdFromAddress } from '@towns-protocol/sdk';
export const useMyUserId = () => {
    const { signerContext } = useTownsContext();
    return useMemo(() => {
        return signerContext ? userIdFromAddress(signerContext.creatorAddress) : undefined;
    }, [signerContext]);
};
//# sourceMappingURL=use-my-user-id.js.map